import { render, staticRenderFns } from "./TestimonialColumn.vue?vue&type=template&id=24836a7c&scoped=true"
import script from "./TestimonialColumn.vue?vue&type=script&lang=js"
export * from "./TestimonialColumn.vue?vue&type=script&lang=js"
import style0 from "./TestimonialColumn.vue?vue&type=style&index=0&id=24836a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24836a7c",
  null
  
)

export default component.exports